module.exports = __webpack_public_path__ + "img/Flag_of_the_United_Kingdom.d1575226.svg";